import { useQueryClient } from '@tanstack/react-query';
import { GetDartsResponse } from '~/types';
import dartKey from './dartKey';

const useDartCache = () => {
  const queryClient = useQueryClient();
  const queryKey = dartKey.getDarts();

  const getCurrentDartCount = () => {
    const cachedData = queryClient.getQueryData<GetDartsResponse>(queryKey);
    const currentDart = cachedData ? cachedData.data.dart : 0;

    return currentDart;
  };

  const decreaseDartInCache = () => {
    const prev = queryClient.getQueryData<GetDartsResponse>(queryKey);
    if (prev && 'data' in prev && prev) {
      queryClient.setQueryData<GetDartsResponse>(queryKey, {
        ...prev,
        data: {
          ...prev.data,
          dart: prev.data.dart - 1,
        },
      });
    }
  };

  return {
    getCurrentDartCount,
    decreaseDartInCache,
  };
};

export default useDartCache;
